import index from "./magazineList.vue";
export default index;
